export default __webpack_public_path__ + "static/media/arrow-left.7f4c66e1.svg";